import { render, staticRenderFns } from "./AdminGenericProductAttributesScreen.vue?vue&type=template&id=ad90a194&scoped=true&"
import script from "./AdminGenericProductAttributesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminGenericProductAttributesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad90a194",
  null
  
)

export default component.exports